import { render } from "./LocationTrailerResultCard.vue?vue&type=template&id=65d9c05b&scoped=true&ts=true"
import script from "./LocationTrailerResultCard.vue?vue&type=script&lang=ts"
export * from "./LocationTrailerResultCard.vue?vue&type=script&lang=ts"

import "./LocationTrailerResultCard.vue?vue&type=style&index=0&id=65d9c05b&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d9c05b"]])

export default __exports__